import { render, staticRenderFns } from "./ExternalCategories.vue?vue&type=template&id=b502082c&scoped=true&"
import script from "./ExternalCategories.vue?vue&type=script&lang=js&"
export * from "./ExternalCategories.vue?vue&type=script&lang=js&"
import style0 from "./ExternalCategories.vue?vue&type=style&index=0&id=b502082c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b502082c",
  null
  
)

export default component.exports